import { render, staticRenderFns } from "./TheLayoutBase.vue?vue&type=template&id=fe6d048a"
import script from "./TheLayoutBase.vue?vue&type=script&lang=ts"
export * from "./TheLayoutBase.vue?vue&type=script&lang=ts"
import style0 from "./TheLayoutBase.vue?vue&type=style&index=0&id=fe6d048a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports